
import React from "react";
import ClosingCostItem from "./ClosingCostItem";
import type { MortgageData } from "../../CalculatorTabs";

interface ClosingCostsListProps {
  mortgageData: MortgageData;
  autoCalculate: boolean;
  onClosingCostChange: (field: keyof MortgageData["closingCosts"], value: number) => void;
}

const ClosingCostsList: React.FC<ClosingCostsListProps> = ({
  mortgageData,
  autoCalculate,
  onClosingCostChange
}) => {
  return (
    <div className="space-y-4">
      <ClosingCostItem
        label="Loan Origination Fee"
        value={mortgageData.closingCosts.loanOrigination}
        disabled={autoCalculate || mortgageData.closingCosts.loanOriginationWaived}
        onChange={(value) => onClosingCostChange('loanOrigination', value)}
        isWaived={mortgageData.closingCosts.loanOriginationWaived}
        builderName={mortgageData.closingCosts.builderName}
        tooltipKey="loanOrigination"
      />
      
      <ClosingCostItem
        label="Appraisal Fee"
        value={mortgageData.closingCosts.appraisalFee}
        disabled={autoCalculate}
        onChange={(value) => onClosingCostChange('appraisalFee', value)}
        tooltipKey="appraisalFee"
      />
      
      <ClosingCostItem
        label="Title Services"
        value={mortgageData.closingCosts.titleServices}
        disabled={autoCalculate}
        onChange={(value) => onClosingCostChange('titleServices', value)}
        tooltipKey="titleServices"
      />
      
      <ClosingCostItem
        label="Government Recording Charges"
        value={mortgageData.closingCosts.governmentRecordingCharges}
        disabled={autoCalculate}
        onChange={(value) => onClosingCostChange('governmentRecordingCharges', value)}
        tooltipKey="governmentRecording"
      />
      
      <ClosingCostItem
        label="Prepaids"
        value={mortgageData.closingCosts.prepaids}
        disabled={autoCalculate}
        onChange={(value) => onClosingCostChange('prepaids', value)}
        tooltipKey="prepaids"
      />
      
      <ClosingCostItem
        label="Initial Escrow Payment"
        value={mortgageData.closingCosts.initialEscrow}
        disabled={autoCalculate}
        onChange={(value) => onClosingCostChange('initialEscrow', value)}
        tooltipKey="initialEscrow"
      />
      
      <ClosingCostItem
        label="Other Costs"
        value={mortgageData.closingCosts.other}
        disabled={autoCalculate}
        onChange={(value) => onClosingCostChange('other', value)}
        tooltipKey="otherClosingCosts"
      />
      
      {mortgageData.loanType === 'va' && (
        <ClosingCostItem
          label="VA Funding Fee"
          value={mortgageData.closingCosts.fundingFee || 0}
          disabled={true}
          onChange={() => {}}
          tooltipKey="vaFundingFee"
        />
      )}
    </div>
  );
};

export default ClosingCostsList;
